import { render, staticRenderFns } from "./VeJwTeachactModal__Style#Drawer.vue?vue&type=template&id=5085f8ea&scoped=true"
import script from "./VeJwTeachactModal__Style#Drawer.vue?vue&type=script&lang=js"
export * from "./VeJwTeachactModal__Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./VeJwTeachactModal__Style#Drawer.vue?vue&type=style&index=0&id=5085f8ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5085f8ea",
  null
  
)

export default component.exports